import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { isAunakProAppRole } from '../constants/aunak-pro-app-roles';
import { AuthSessionService } from '../services/auth-session.service';

/**
 * Sends Aunak Pro app roles away from web dashboard to the app landing page.
 */
@Injectable({ providedIn: 'root' })
export class RedirectAunakProAppUsersGuard implements CanActivate {
  constructor(
    private session: AuthSessionService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.session.ready().pipe(
      map((profile) => {
        if (profile && isAunakProAppRole(profile.role)) {
          return this.router.createUrlTree(['/aunak-pro-app']);
        }
        return true;
      }),
    );
  }
}
